"use client";

import { cn } from "@/lib/utils";
import type { BuiltInProviderType } from "next-auth/providers/index";
import { signIn } from "next-auth/react";
import { type FC, useState } from "react";
import { Icons } from "../Icons";
import { Button } from "../ui/button";
import { toast } from "../ui/use-toast";

interface UserAuthFormProps extends React.HTMLAttributes<HTMLDivElement> {
  error?: string;
}

const UserAuthForm: FC<UserAuthFormProps> = ({ error, className, ...props }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const externalLogin =
    (provider: BuiltInProviderType = "google") =>
    async () => {
      setIsLoading(true);

      try {
        await signIn(provider, { callbackUrl: "/" });
      } catch (error) {
        console.error("Error signing in", error);

        toast({
          title: "Uh oh! Something went wrong.",
          description: "There was an error signing in. Please try again.",
          variant: "destructive",
        });
      } finally {
        setIsLoading(false);
      }
    };

  return (
    <>
      <div className={cn("flex flex-col gap-4 justify-center", className)} {...props}>
        <Button size={"sm"} className="w-full" onClick={externalLogin("google")}>
          {!isLoading && <Icons.Google className="w-4 h-4 mr-2" />}
          Login with Google
        </Button>
      </div>

      {error && <p className="text-center text-red-500">{error}</p>}
    </>
  );
};

export default UserAuthForm;
